// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UpdateSidebarMenu.module.css */

/* ===== SIDEBAR WRAPPER ===== */
.UpdateSidebarMenu_sidebar_wrapper__KQF82 {
  position: relative;
  height: 100%;
  overflow-y: hidden;
  background: var(--white-color);
  display: flex;
  flex-direction: column;
}

.UpdateSidebarMenu_sidebarListItm__zgFnK {
  width: 100%;
  overflow-x: hidden;
}

/* ===== GROUP VISIBILITY ===== */
.UpdateSidebarMenu_sidebar_wrapper__KQF82 .UpdateSidebarMenu_groupLabel__eLDn5,
.UpdateSidebarMenu_sidebar_wrapper__KQF82 .UpdateSidebarMenu_groupArrow__viKKy {
  display: none;
}

.UpdateSidebarMenu_sidebar_wrapper__KQF82:hover .UpdateSidebarMenu_groupLabel__eLDn5,
.UpdateSidebarMenu_sidebar_wrapper__KQF82:hover .UpdateSidebarMenu_groupArrow__viKKy {
  display: inline-block;
}

.UpdateSidebarMenu_sidebar_wrapper__KQF82:hover .UpdateSidebarMenu_menuGroupItems__6hONt {
  display: flex;
}

.UpdateSidebarMenu_sidebar_wrapper__KQF82 .UpdateSidebarMenu_menuGroupItems__6hONt {
  display: none;
}

/* ===== MENU GROUP HEADER ===== */
.UpdateSidebarMenu_menuGroupHeader__6fmaX {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
}

.UpdateSidebarMenu_menuGroupHeader__6fmaX:hover {
  background: #f3f4f6;
  color: #1f2937;
}

/* .sidebar_wrapper:hover .menuGroupHeader {
  justify-content: flex-start;
} */

/* Active Menu Group Header */
.UpdateSidebarMenu_menuGroupHeader__6fmaX.UpdateSidebarMenu_menuGroupActive__0GIQt {
  background: var(--gradient-hero);
  color: var(--white-color);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.UpdateSidebarMenu_menuGroupHeader__6fmaX.UpdateSidebarMenu_menuGroupActive__0GIQt .UpdateSidebarMenu_groupIcon__fpxUm,
.UpdateSidebarMenu_menuGroupHeader__6fmaX.UpdateSidebarMenu_menuGroupActive__0GIQt .UpdateSidebarMenu_groupLabel__eLDn5,
.UpdateSidebarMenu_menuGroupHeader__6fmaX.UpdateSidebarMenu_menuGroupActive__0GIQt .UpdateSidebarMenu_groupArrow__viKKy {
  color: var(--white-color);
}

/* ===== GROUP ICON, LABEL, ARROW ===== */
.UpdateSidebarMenu_groupIcon__fpxUm {
  /* margin-right: 8px; */
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #6b7280;
}

.UpdateSidebarMenu_groupLabel__eLDn5 {
  flex: 1 1;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  display: none;
  margin-left: 18px;
}

.UpdateSidebarMenu_groupArrow__viKKy {
  display: flex;
  align-items: center;
  color: #6b7280;
  font-size: 12px;
  transition: transform 0.2s;
  display: none;
}

.UpdateSidebarMenu_sidebar_wrapper__KQF82:hover .UpdateSidebarMenu_groupLabel__eLDn5,
.UpdateSidebarMenu_sidebar_wrapper__KQF82:hover .UpdateSidebarMenu_groupArrow__viKKy {
  display: flex;
}

/* ===== MENU GROUP ITEMS ===== */
.UpdateSidebarMenu_menuGroup__fHq\\+W {
  margin-bottom: 4px;
}

.UpdateSidebarMenu_menuGroupItems__6hONt {
  padding-left: 0;
  display: none;
}

.UpdateSidebarMenu_sidebar_wrapper__KQF82:hover .UpdateSidebarMenu_menuGroupItems__6hONt {
  display: flex;
}

/* Adjust SidebarList items inside group */
.UpdateSidebarMenu_menuGroupItems__6hONt .UpdateSidebarMenu_sidebarItem__cBhKx {
  padding-left: 36px;
}

/* ===== SIDEBAR ITEM ===== */
.UpdateSidebarMenu_sidebarItem__cBhKx {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  gap: 12px;
  color: #6b7280;
  position: relative;
}

.UpdateSidebarMenu_sidebarItem__cBhKx:hover {
  background: #f3f4f6;
  color: #1f2937;
}

.UpdateSidebarMenu_sidebarItem__cBhKx.UpdateSidebarMenu_active__Y7mxi {
  color: var(--primary);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  background: #e6edff;
}

/* ===== STEP CIRCLE ===== */
.UpdateSidebarMenu_stepContainer__Fh-pA {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.UpdateSidebarMenu_stepCircle__lsTHL {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  background: white;
  transition: all 0.3s ease;
  position: relative;
  display: block !important;
}

/* Active circle */
.UpdateSidebarMenu_stepCircle__lsTHL.UpdateSidebarMenu_stepActive__9HUev {
  border-color: var(--primary-light);
  background: var(--primary-dark);
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.2);
  transform: scale(1.1);
}

/* Completed circle */
.UpdateSidebarMenu_stepCircle__lsTHL.UpdateSidebarMenu_stepCompleted__aDWUd {
  border-color: #10b981;
  background: #10b981;
}

/* Active pulse animation */
.UpdateSidebarMenu_stepCircle__lsTHL.UpdateSidebarMenu_stepActive__9HUev::after {
  content: "";
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border-radius: 50%;
  border: 2px solid rgba(102, 126, 234, 0.3);
  animation: UpdateSidebarMenu_pulse-ring__UJ9OV 2s ease-in-out infinite;
}

@keyframes UpdateSidebarMenu_pulse-ring__UJ9OV {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

/* ===== CONTENT ===== */
.UpdateSidebarMenu_stepContent__Qoxe4 {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}

.UpdateSidebarMenu_stepIcon__JZ6v3 {
  display: flex;
  align-items: center;
  font-size: 18px;
  flex-shrink: 0;
}

.UpdateSidebarMenu_stepText__7c3rU {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.UpdateSidebarMenu_sidebarItem__cBhKx.UpdateSidebarMenu_active__Y7mxi .UpdateSidebarMenu_stepText__7c3rU {
  color: var(--primary);
}

/* ===== SIDEBAR LIST ===== */
.UpdateSidebarMenu_sidebarList__Uv2bb,
.UpdateSidebarMenu_groupedList__XnwOn {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.UpdateSidebarMenu_sidebarList__Uv2bb li,
.UpdateSidebarMenu_groupedList__XnwOn li {
  padding: 0;
  margin: 0;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .UpdateSidebarMenu_stepCircle__lsTHL {
    width: 10px;
    height: 10px;
  }

  .UpdateSidebarMenu_sidebarItem__cBhKx {
    padding: 8px 12px;
  }

  .UpdateSidebarMenu_stepText__7c3rU {
    font-size: 13px;
  }
}

/* ===== MOBILE/TABLET ===== */
@media (max-width: 768px) {
  /* Always show group text and arrow */
  .UpdateSidebarMenu_sidebar_wrapper__KQF82 .UpdateSidebarMenu_groupLabel__eLDn5,
  .UpdateSidebarMenu_sidebar_wrapper__KQF82 .UpdateSidebarMenu_groupArrow__viKKy {
    display: flex !important;
  }

  /* Always show group items */
  .UpdateSidebarMenu_sidebar_wrapper__KQF82 .UpdateSidebarMenu_menuGroupItems__6hONt {
    display: flex !important;
    flex-direction: column;
  }
  .UpdateSidebarMenu_groupedMenu__VhQvH{
    width: 100%;
  }

  /* Restore normal header alignment */
  .UpdateSidebarMenu_menuGroupHeader__6fmaX {
    justify-content: flex-start;
  }

  /* Optional: slightly reduce spacing */
  .UpdateSidebarMenu_sidebarItem__cBhKx {
    padding: 12px;
  }

  .UpdateSidebarMenu_stepText__7c3rU {
    display: block;
    font-size: 13px;
  }

  .UpdateSidebarMenu_groupLabel__eLDn5 {
    display: block !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Sidebar/UpdateSidebarMenu.module.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,gCAAgC;AAChC;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;;EAEE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;GAEG;;AAEH,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,sEAA6C;AAC/C;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;;EAEE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE,qCAAqC;EACrC;;IAEE,wBAAwB;EAC1B;;EAEA,4BAA4B;EAC5B;IACE,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;;EAEA,oCAAoC;EACpC;IACE,2BAA2B;EAC7B;;EAEA,sCAAsC;EACtC;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* UpdateSidebarMenu.module.css */\n\n/* ===== SIDEBAR WRAPPER ===== */\n.sidebar_wrapper {\n  position: relative;\n  height: 100%;\n  overflow-y: hidden;\n  background: var(--white-color);\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebarListItm {\n  width: 100%;\n  overflow-x: hidden;\n}\n\n/* ===== GROUP VISIBILITY ===== */\n.sidebar_wrapper .groupLabel,\n.sidebar_wrapper .groupArrow {\n  display: none;\n}\n\n.sidebar_wrapper:hover .groupLabel,\n.sidebar_wrapper:hover .groupArrow {\n  display: inline-block;\n}\n\n.sidebar_wrapper:hover .menuGroupItems {\n  display: flex;\n}\n\n.sidebar_wrapper .menuGroupItems {\n  display: none;\n}\n\n/* ===== MENU GROUP HEADER ===== */\n.menuGroupHeader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 16px;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  position: relative;\n}\n\n.menuGroupHeader:hover {\n  background: #f3f4f6;\n  color: #1f2937;\n}\n\n/* .sidebar_wrapper:hover .menuGroupHeader {\n  justify-content: flex-start;\n} */\n\n/* Active Menu Group Header */\n.menuGroupHeader.menuGroupActive {\n  background: var(--gradient-hero);\n  color: var(--white-color);\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.menuGroupHeader.menuGroupActive .groupIcon,\n.menuGroupHeader.menuGroupActive .groupLabel,\n.menuGroupHeader.menuGroupActive .groupArrow {\n  color: var(--white-color);\n}\n\n/* ===== GROUP ICON, LABEL, ARROW ===== */\n.groupIcon {\n  /* margin-right: 8px; */\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  color: #6b7280;\n}\n\n.groupLabel {\n  flex: 1;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  display: none;\n  margin-left: 18px;\n}\n\n.groupArrow {\n  display: flex;\n  align-items: center;\n  color: #6b7280;\n  font-size: 12px;\n  transition: transform 0.2s;\n  display: none;\n}\n\n.sidebar_wrapper:hover .groupLabel,\n.sidebar_wrapper:hover .groupArrow {\n  display: flex;\n}\n\n/* ===== MENU GROUP ITEMS ===== */\n.menuGroup {\n  margin-bottom: 4px;\n}\n\n.menuGroupItems {\n  padding-left: 0;\n  display: none;\n}\n\n.sidebar_wrapper:hover .menuGroupItems {\n  display: flex;\n}\n\n/* Adjust SidebarList items inside group */\n.menuGroupItems .sidebarItem {\n  padding-left: 36px;\n}\n\n/* ===== SIDEBAR ITEM ===== */\n.sidebarItem {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-radius: 8px;\n  gap: 12px;\n  color: #6b7280;\n  position: relative;\n}\n\n.sidebarItem:hover {\n  background: #f3f4f6;\n  color: #1f2937;\n}\n\n.sidebarItem.active {\n  color: var(--primary);\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n  background: #e6edff;\n}\n\n/* ===== STEP CIRCLE ===== */\n.stepContainer {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  min-width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.stepCircle {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 2px solid #d1d5db;\n  background: white;\n  transition: all 0.3s ease;\n  position: relative;\n  display: block !important;\n}\n\n/* Active circle */\n.stepCircle.stepActive {\n  border-color: var(--primary-light);\n  background: var(--primary-dark);\n  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.2);\n  transform: scale(1.1);\n}\n\n/* Completed circle */\n.stepCircle.stepCompleted {\n  border-color: #10b981;\n  background: #10b981;\n}\n\n/* Active pulse animation */\n.stepCircle.stepActive::after {\n  content: \"\";\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  right: -4px;\n  bottom: -4px;\n  border-radius: 50%;\n  border: 2px solid rgba(102, 126, 234, 0.3);\n  animation: pulse-ring 2s ease-in-out infinite;\n}\n\n@keyframes pulse-ring {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.5);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n/* ===== CONTENT ===== */\n.stepContent {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n\n.stepIcon {\n  display: flex;\n  align-items: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.stepText {\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: all 0.3s ease;\n}\n\n.sidebarItem.active .stepText {\n  color: var(--primary);\n}\n\n/* ===== SIDEBAR LIST ===== */\n.sidebarList,\n.groupedList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n}\n\n.sidebarList li,\n.groupedList li {\n  padding: 0;\n  margin: 0;\n}\n\n/* ===== RESPONSIVE ===== */\n@media (max-width: 768px) {\n  .stepCircle {\n    width: 10px;\n    height: 10px;\n  }\n\n  .sidebarItem {\n    padding: 8px 12px;\n  }\n\n  .stepText {\n    font-size: 13px;\n  }\n}\n\n/* ===== MOBILE/TABLET ===== */\n@media (max-width: 768px) {\n  /* Always show group text and arrow */\n  .sidebar_wrapper .groupLabel,\n  .sidebar_wrapper .groupArrow {\n    display: flex !important;\n  }\n\n  /* Always show group items */\n  .sidebar_wrapper .menuGroupItems {\n    display: flex !important;\n    flex-direction: column;\n  }\n  .groupedMenu{\n    width: 100%;\n  }\n\n  /* Restore normal header alignment */\n  .menuGroupHeader {\n    justify-content: flex-start;\n  }\n\n  /* Optional: slightly reduce spacing */\n  .sidebarItem {\n    padding: 12px;\n  }\n\n  .stepText {\n    display: block;\n    font-size: 13px;\n  }\n\n  .groupLabel {\n    display: block !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar_wrapper": `UpdateSidebarMenu_sidebar_wrapper__KQF82`,
	"sidebarListItm": `UpdateSidebarMenu_sidebarListItm__zgFnK`,
	"groupLabel": `UpdateSidebarMenu_groupLabel__eLDn5`,
	"groupArrow": `UpdateSidebarMenu_groupArrow__viKKy`,
	"menuGroupItems": `UpdateSidebarMenu_menuGroupItems__6hONt`,
	"menuGroupHeader": `UpdateSidebarMenu_menuGroupHeader__6fmaX`,
	"menuGroupActive": `UpdateSidebarMenu_menuGroupActive__0GIQt`,
	"groupIcon": `UpdateSidebarMenu_groupIcon__fpxUm`,
	"menuGroup": `UpdateSidebarMenu_menuGroup__fHq+W`,
	"sidebarItem": `UpdateSidebarMenu_sidebarItem__cBhKx`,
	"active": `UpdateSidebarMenu_active__Y7mxi`,
	"stepContainer": `UpdateSidebarMenu_stepContainer__Fh-pA`,
	"stepCircle": `UpdateSidebarMenu_stepCircle__lsTHL`,
	"stepActive": `UpdateSidebarMenu_stepActive__9HUev`,
	"stepCompleted": `UpdateSidebarMenu_stepCompleted__aDWUd`,
	"pulse-ring": `UpdateSidebarMenu_pulse-ring__UJ9OV`,
	"stepContent": `UpdateSidebarMenu_stepContent__Qoxe4`,
	"stepIcon": `UpdateSidebarMenu_stepIcon__JZ6v3`,
	"stepText": `UpdateSidebarMenu_stepText__7c3rU`,
	"sidebarList": `UpdateSidebarMenu_sidebarList__Uv2bb`,
	"groupedList": `UpdateSidebarMenu_groupedList__XnwOn`,
	"groupedMenu": `UpdateSidebarMenu_groupedMenu__VhQvH`
};
export default ___CSS_LOADER_EXPORT___;
